import { bridgeRequest, httpRequest } from 'common'

import type { IGetUserEntitiesResponse } from '../types'
import { entityMap, TEntity } from '../types/app-context/components/utils'
import { getUserEntitiesEndpoint } from '../utils'

interface IBridgeResponse<T> {
  httpStatus: number
  response: T
}

const getUserEntityKeys = (response: IGetUserEntitiesResponse): TEntity[] =>
  Object.keys(response.accountOrganizations).map((key) => entityMap[key])

const getUserEntitiesBridge = async () => {
  const { response } = await bridgeRequest<IBridgeResponse<IGetUserEntitiesResponse>>({
    endpoint: getUserEntitiesEndpoint,
    returnAllResponse: true,
  })

  return response
}

const getUserEntitiesHttpRequest = () =>
  httpRequest<IGetUserEntitiesResponse>(getUserEntitiesEndpoint)

const getUserEntities = () => getUserEntitiesBridge()

export { getUserEntitiesBridge, getUserEntitiesHttpRequest, getUserEntities, getUserEntityKeys }
